export default "__VITE_ASSET__CHPdG9ua__"